export default "__VITE_ASSET__QdwrHEof__"